import React, { useEffect, useState } from 'react';
import moment from 'moment';

import Cron from './cron';

export function Cronometro({
  minutes,
  title,
  emAndamento,
  observacaoInterna,
}) {
  const [minutesScreen, setMinutesScreen] = useState(0);
  const [secondsScreen, setSecondsScreen] = useState(0);
  const [tipoAtendimento, setTipoAtendimento] = useState(0);

  useEffect(() => {
    const initialData = async () => {
      const inicio = moment(
        emAndamento?.inicioAtendimento || emAndamento?.data?.inicioAtendimento
      ).format('kk:mm:ss');
      const hojeHora = moment().format('kk:mm:ss');
      let inicioAtendimentoMoment = '';
      hojeHora < inicio
        ? (inicioAtendimentoMoment = moment.duration(inicio).subtract(hojeHora))
        : (inicioAtendimentoMoment = moment
          .duration(hojeHora)
          .subtract(inicio));
      const momentMinutos = inicioAtendimentoMoment._data.minutes;
      const momentSegundos = inicioAtendimentoMoment._data.seconds;

      setTipoAtendimento(
        emAndamento?.idTipoValidacao || emAndamento?.data?.idTipoValidacao
      );
      setMinutesScreen(momentMinutos);
      setSecondsScreen(momentSegundos);
    };
    initialData();
  }, [emAndamento]);

  return (
    <Cron
      title={title}
      minutes={+minutes}
      minutesScreen={+minutesScreen}
      secondsScreen={+secondsScreen}
      tipoAtendimento={tipoAtendimento}
      idAtendimento={emAndamento?.id || emAndamento?.data?.id}
      observacaoInterna={observacaoInterna}
    />
  );
}
